import React, { useState, useEffect, useMemo } from 'react'
import './formstyles.scss'
// import { courseArray } from '../../Constants/courses/c200hr'
import { AllCourses, alibaugArr } from '../../Views/Courses/Constants/courses'
import { useParams } from 'react-router-dom'
import { validateEmail } from '../../../../helpers'
import { Link, useLocation, useSearchParams, useNavigate } from 'react-router-dom'
import DisclaimerPolicy from '../DisclaimerPolicy'
import { useDispatch, useSelector } from 'react-redux'
import Personal from './Personal'
import { legacy2 } from '../../assets/icons/icon'
import { authBaseDomain, cmsBaseDomain, razorPayKey, cmsRedisBaseDomain } from '../../../../Constants/appSettings'
import axios from 'axios'
import { handleCTProccedToPayment } from '../../../../CleverTap/buttonClicked'
import { trackPageView } from '../../../../CleverTap/pageViewEvents'
import { handleCTCoursePaymentPageVisit, handleCTPaymentCompletedCourse, handleCTPaymentFailed, setupUserProfile, triggerCourseEvent, triggerCourseEventFor21DaysCourse, triggerCourseEventFor7DaysCourse } from '../../../../CleverTap/buttonClicked'
import EnrollmentForm from './EnrollmentForm'
import PaymentGatewaySelection from './PaymentGatewaySelection'
import ReactGA from 'react-ga4';
import { fetchUserData } from '../../Views/Authentication/Auth.actions'

const Enrollment = () => {
  const { user } = useSelector((state) => state.auth)
  const { courseId } = useParams()
  const [currentCourse, setCurrentCourse] = useState({})
  const [courseDate, setCourseDate] = useState(null)
  const [Params] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation();
  const psychotherapyProgramsUrl = '/psychotherapy-counselling/psychotherapy-detail#programs-section';
  const psychotherapyEnrollmentPaths = useMemo(
    () =>
      new Set([
        '/enrollment/swadhyaya-and-emo-energy-reset-basic-online',
        '/enrollment/swadhyaya-and-emo-energy-reset-basic-offline',
        '/enrollment/integral-chakra-psychology-advanced-module',
        '/enrollment/combined-basic-module-advanced-module',
        '/enrollment/combined-basic-module-advanced-module-offline',
        '/enrollment/higher-diploma-in-yoga-psychotherapy-Counselling',
        '/enrollment/level-1-and-level-2-combined-online',
        '/enrollment/level-1-and-level-2-combined-offline',
      ]),
    []
  );
  const shouldRedirectToPsychotherapyPrograms = psychotherapyEnrollmentPaths.has(location.pathname);
  const handleCloseNavigation = () => {
    if (shouldRedirectToPsychotherapyPrograms) {
      window.location.assign(psychotherapyProgramsUrl);
      return;
    }
    navigate('/courses');
  };
  const [isEditStudentOpen, setEditStudentOpen] = useState(false);
  const addressLine1 = useSelector((state) => state.auth.user.data?.addressLine1);
  const addressLine2 = useSelector((state) => state.auth.user.data?.addressLine2);
  const pincodeFromRedux = useSelector((state) => state.auth.user.data?.pincode);
  const countryFromRedux = useSelector((state) => state.auth.user.data?.country);
  const stateFromRedux = useSelector((state) => state.auth.user.data?.state);
  const genderFromRedux = useSelector((state) => state.auth.user.data?.gender);
  const dispatch = useDispatch();

  // Legacy psychotherapy landing page links to the unsuffixed basic module slug.
  useEffect(() => {
    if (courseId === 'swadhyaya-and-emo-energy-reset-basic') {
      navigate(`/enrollment/swadhyaya-and-emo-energy-reset-basic-online${location.search}`, { replace: true });
    }
  }, [courseId, location.search, navigate]);

  useEffect(() => {
    let currentCrs = AllCourses.find((item) => item.key === courseId)
    if (!currentCrs) {
      let aliCourse = alibaugArr.find((item) => item.key === courseId)
      setCurrentCourse(aliCourse)
      setCourseDate(Params.get('date'))
      localStorage.removeItem('courseEndDate')
    }
    else {
      setCurrentCourse(currentCrs)
      setCourseDate(Params.get('date'))
      localStorage.removeItem('courseEndDate')
    }
    // setDate(
    //   today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
    // )
  }, [courseId, Params])

  const [empty, setEmpty] = useState(0)
  const [courseFee, setCourseFee] = useState(null)
  const [bold, setBold] = useState(0)
  const [listData, setListData] = useState([])
  const [qualificationData, setQualificationData] = useState([])
  const [courseAsset1, setCourseAsset1] = useState(null)
  const [courseAsset2, setCourseAsset2] = useState(null)
  const [uploadCheck, setUploadCheck] = useState(true)
  const [uploadError, setUploadError] = useState(false)
  const [showLevel2ConfirmationModal, setShowLevel2ConfirmationModal] = useState(false)

  // Error state for swadhyaya course validation
  const [formatError, setFormatError] = useState('');
  const [dateError, setDateError] = useState('');


  const [sessionId, setSessionId] = useState('');
  const [startTime, setStartTime] = useState(0);
  const { isLoggedIn } = useSelector((state) => state.auth)

  // State for payment gateway screen
  const [showPaymentGateway, setShowPaymentGateway] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [selectedCourseDuration, setSelectedCourseDuration] = useState(null);

  // Debug: Log when modal state changes
  useEffect(() => {
    console.log('showLevel2ConfirmationModal changed:', showLevel2ConfirmationModal);
  }, [showLevel2ConfirmationModal])
  const [formData, setFormData] = useState({
    name: user?.data?.firstName,
    lname: '',
    phone: '',
    email: user?.data?.email,
    address1: '',
    address2: '',
    country: '',
    state: '',
    city: '',
    pincode: '',
    AGE: '',
    nationality: '',
    gender: '',
    school: '',
    course: '',
    completion: '',
    company: '',
    worktill: '',
    workfrom: '',
    leavejob: '',
    resignation: '',
    medicalstatus: '',
    sourceinfo: '',
    source: '',
    purpose: '',
    info: '',
    mode: '',
    residental: '',
    sdate: '',
    terms: '',
    startDate: '',
    endDate: '',
    months: '',
    endDateFormat: '',
    uploadedDocument: []
  })

  const handleEmpty1 = (e) => {
    e.preventDefault()
  }
  function parseDate(dateStr) {
    const [day, month, year] = dateStr.split('/').map(Number); // Split the date string and convert parts to numbers
    // Create a new Date object (months are 0-based, so subtract 1 from month)
    return new Date(year, month - 1, day);
  }

  function dateDurationChange(months) {
    console.log("Months ", months);
    let originalFee = AllCourses.find((item) => item.key === courseId)
    const monthsVal = typeof months === 'number' ? months : (months?.value || 0);
    // alert(originalFee?.fees?.onlineFee,months )
    if (originalFee?.fees?.onlineFee && monthsVal) {
      let newAmnt = originalFee?.fees?.onlineFee * monthsVal;

      const specialCourses = [
        "/asana-regular-classes-on-campus",
        "/asana-regular-classes-on-campus-women",
        "/asana-regular-classes-online",
        "/weekend-classes",
        "/weekend-classes-online"
      ];
      const isSpecial = specialCourses.some(path => path.includes(courseId));

      const isDateAfter2025 = (dateStr) => {
        if (!dateStr) return false;
        try {
          const [day, month, year] = dateStr.split('/').map(Number);
          const selectedDate = new Date(year, month - 1, day);
          const cutoffDate = new Date(2025, 11, 31);
          return selectedDate > cutoffDate;
        } catch (err) {
          return false;
        }
      };

      if (monthsVal == 12 && isSpecial && isDateAfter2025(formData.startDate)) {
        newAmnt = 12000;
      } else if (monthsVal == 12) {
        newAmnt = newAmnt - 2200
      }

      // DO NOT modify currentCourse.fees - it should always keep the base fee
      // The multiplication is handled in CourseDetails.jsx useEffect
      // Just set the display price
      setCourseFee(newAmnt)
    }
  }

  const setEndDate = (months, startDate) => {
    const monthsVal = typeof months === 'number' ? months : (months?.value || 0);
    let endDate = formatDate(addMonths(parseDate(startDate), monthsVal))
    let originalFee = AllCourses.find((item) => item.key === courseId)
    let newAmnt = originalFee?.fees?.onlineFee * monthsVal;

    const specialCourses = [
      "/asana-regular-classes-on-campus",
      "/asana-regular-classes-on-campus-women",
      "/asana-regular-classes-online",
      "/weekend-classes",
      "/weekend-classes-online"
    ];
    const isSpecial = specialCourses.some(path => path.includes(courseId));

    const isDateAfter2025 = (dateStr) => {
      if (!dateStr) return false;
      try {
        const [day, month, year] = dateStr.split('/').map(Number);
        const selectedDate = new Date(year, month - 1, day);
        const cutoffDate = new Date(2025, 11, 31);
        return selectedDate > cutoffDate;
      } catch (err) {
        return false;
      }
    };

    if (monthsVal == 12 && isSpecial && isDateAfter2025(startDate)) {
      newAmnt = 12000;
    } else if (monthsVal == 12) {
      newAmnt = newAmnt - 2200
    }

    // DO NOT modify currentCourse.fees - it should always keep the base fee
    // The multiplication is handled in CourseDetails.jsx useEffect
    setFormData((prev) => {
      return { ...prev, endDateFormat: endDate }
    })
    // alert(endDate)
    setCourseFee(newAmnt)
  }
  // Function to add months to a given date
  function addMonths(startDate, months) {
    const date = startDate; // Create a Date object from the start date
    // date.setMonth(date.getMonth() + months); // Add the number of months
    // console.log(date);
    let totalDays = months * 30
    date.setDate(date.getDate() + (totalDays - 1));
    return date;
  }
  function formatDate(date) {
    const day = date.getDate().toString().padStart(2, '0'); // Day with leading zero
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month with leading zero
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://checkout.razorpay.com/v1/checkout.js'
    script.async = true
    document.body.appendChild(script)

    const cfScript = document.createElement('script')
    cfScript.src = 'https://sdk.cashfree.com/js/v3/cashfree.js'
    cfScript.async = true
    document.body.appendChild(cfScript)

    localStorage.setItem('addressDataNew', JSON.stringify({
      address1: addressLine1 || '',
      address2: addressLine2 || '',
      country: countryFromRedux || '',
      state: stateFromRedux || '',
      pincode: pincodeFromRedux || '',
      gender: genderFromRedux || ''
    }));
  }, [])

  const [mail, setmail] = useState(null)
  const [savedMailTemplate, setSavedMailTemplate] = useState(null)

  // Handle payment gateway selection and submit payment
  const handlePaymentSubmit = async (selectedGateway, totalPayable, mailTemplateOverride = null) => {
    try {
      setIsLoad(true);

      // Get enrollment form ID from localStorage (it should be set during form submission)
      const enrollmentFormId = localStorage.getItem('enrollmentFormId');

      if (!enrollmentFormId) {
        console.error('Enrollment form ID not found');
        setIsLoad(false);
        return;
      }

      // Shared helpers for both gateways
      const sanitizeAmount = (amt) => {
        if (typeof amt === 'string') {
          return amt.replace(/,/g, '');
        }
        return amt;
      };
      const finalAmount = localStorage.getItem('courseFee') || courseFee;
      const mailTemplateToSend = mailTemplateOverride || savedMailTemplate;

      // Prepare options based on selected gateway
      if (selectedGateway === 'razorpay') {
        // Create Razorpay payment order with totalPayable amount (includes GST + gateway fees)
        const paymentOrderResponse = await axios.post(`${cmsBaseDomain}/payment/order?enrollmentFormId=${enrollmentFormId}`, {
          amount: Number(sanitizeAmount(totalPayable || finalAmount)),
          notes: currentCourse.metaDescription,
          objectType: 'ENROLLMENT'
        });

        if (!paymentOrderResponse?.data?.amount || !paymentOrderResponse?.data?.id) {
          setIsLoad(false);
          return;
        }

        // Load and open Razorpay
        const options = {
          key: razorPayKey,
          amount: paymentOrderResponse.data.amount,
          currency: 'INR',
          name: 'The Yoga Institute',
          description: 'Course Transaction',
          order_id: paymentOrderResponse.data.id,
          handler: async (res) => {
            if (res.razorpay_payment_id && res.razorpay_order_id && res.razorpay_signature) {
              // Payment successful
              if (currentCourse.key !== 'detox-cleanse-yoga-retreat' && currentCourse.key !== 'deep-dive-yoga-meditation-retreat' && currentCourse.key != '2-days-relax-restore-yoga-retreat') {
                const verificationResponse = await fetch(
                  `${cmsBaseDomain}/payment/manualVerification`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ paymentId: res.razorpay_payment_id }),
                  }
                );
                const verificationData = await verificationResponse.json();
                console.log("Manual verification response:", verificationData);
                try {
                  if (mailTemplateToSend) {
                    await axios.post(`${authBaseDomain}/ali/mail`, mailTemplateToSend);
                  }
                } catch (mailError) {
                  console.error('Failed to send confirmation mail:', mailError);
                }
              }

              handleCTPaymentCompletedCourse({
                paymentStatus: "Success",
                courseName: currentCourse?.clevertapData?.name,
                courseCategory: currentCourse?.clevertapData?.courseCategory,
                startDate: formData.startDate,
                endDate: formData.sdate,
                date: formData.sdate,
                pageName: window.location.href,
                checkoutUrl: window.location.href,
                pageUrl: window.location.href,
                fee: courseFee,
                timings: currentCourse.timing,
                tenure: currentCourse?.tenure,
                onlineMode: currentCourse?.onlineInfo?.courseMode,
                residentialMode: currentCourse?.residentialInfo?.courseMode,
                nonResidentialMode: currentCourse?.nonResidentialInfo?.courseMode,
                residentialLocation: currentCourse?.residentialInfo?.residentialMode,
                nonResidentialLocation: currentCourse?.nonResidentialInfo?.nonResidentialMode,
                courseType: currentCourse?.clevertapData?.courseType,
                courseCertificate: currentCourse?.clevertapData?.courseCertificate,
                courseSubType: currentCourse?.clevertapData?.courseSubType,
                language: currentCourse?.language,
                courseTopCategory: currentCourse?.clevertapData?.courseTopCategory,
                mode: formData.mode,
                batchNo: currentCourse.batch,
                preRequisite: currentCourse?.clevertapData?.coursePreRequisite,
                status: "Success",
                name: formData.name,
                emailId: formData.email,
                phoneNumber: formData.phone,
                state: formData.state,
                city: formData.city,
                pinCode: formData.pincode,
                gender: formData.gender?.toUpperCase(),
                age: formData.AGE,
                nationality: formData.nationality,
              });

              ReactGA.event('purchase', {
                currency: 'INR',
                value: courseFee,
                transaction_id: res.razorpay_payment_id,
                items: [{
                  item_name: currentCourse?.title,
                  item_id: currentCourse?.courseCategory,
                  price: courseFee,
                  quantity: 1
                }]
              });

              setIsLoad(false);
              navigate(`/enrollment_thankyou/${currentCourse.key}`);
            } else {
              handleCTPaymentFailed({
                paymentStatus: "Failure",
                courseName: formData.courseName,
                courseCategory: formData.category,
                startDate: formData.sdate,
                endDate: formData.sdate,
                date: formData.sdate,
                pageName: window.location.href,
                checkoutUrl: window.location.href,
                pageUrl: window.location.href,
                fee: courseFee,
                mode: formData.mode,
                timings: currentCourse.timing,
                batchNo: currentCourse.batch,
                status: "Failure",
                name: formData.name,
                emailId: formData.email,
                phoneNumber: formData.phone,
                state: formData.state,
                city: formData.city,
                pinCode: formData.pincode,
                gender: formData.gender?.toUpperCase(),
                age: formData.AGE,
                nationality: formData.nationality,
              });
              setIsLoad(false);
            }
          },
          prefill: {
            name: formData.name,
            email: formData.email,
            contact: formData.phone
          },
          notes: {
            courseName: currentCourse.title,
            name: formData.name,
            email: formData.email,
            contact: formData.phone,
            date: formData.sdate,
            time: currentCourse.timing,
            mode: formData.mode,
          },
          theme: {
            color: '#3399cc'
          },
          modal: {
            ondismiss: function () {
              setIsLoad(false);
              console.log("Payment modal closed by user.");
            },
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } else if (selectedGateway === 'cashfree') {
        // Implement Cashfree payment gateway integration
        console.log('Cashfree payment gateway selected. EnrollmentFormId:', enrollmentFormId);

        const rawAmount = totalPayable || finalAmount;
        const cfAmount = Number(sanitizeAmount(rawAmount));

        const payload = {
          amount: cfAmount,
          courseAmount: cfAmount,
          totalAmount: cfAmount,
          gstAmount: 0,
          paymentGatewayFeeAmount: 0,
          notes: currentCourse.title || currentCourse.metaDescription || "Enrollment Payment",
          objectType: 'ENROLLMENT',
          type: 'CASHFREE',
          customer_details: {
            customer_id: user?.data?.["_id"] || `cust_${Date.now()}`,
            customer_email: formData.email,
            customer_phone: String(formData.phone).replace(/[^0-9]/g, '').slice(-10)
          },
          order_meta: {
            return_url: `${window.location.origin}/enrollment_thankyou/${currentCourse.key}?order_id={order_id}`
          }
        };

        console.log('Creating Cashfree order with payload:', payload);

        const cashfreeOrderResponse = await axios.post(`${cmsRedisBaseDomain}/payment/v2/order?enrollmentFormId=${enrollmentFormId}`, payload);

        console.log('Cashfree order response:', cashfreeOrderResponse.data);

        const payment_session_id = cashfreeOrderResponse?.data?.payment_session_id || cashfreeOrderResponse?.data?.data?.payment_session_id;
        const orderId = cashfreeOrderResponse?.data?.order_id || cashfreeOrderResponse?.data?.data?.order_id;

        console.log('order id ', orderId, '---', cashfreeOrderResponse)

        if (!payment_session_id) {
          console.error('Failed to create Cashfree order - payment_session_id missing', cashfreeOrderResponse?.data);
          setIsLoad(false);
          return;
        }

        if (!window.Cashfree) {
          console.error('Cashfree SDK not loaded');
          setIsLoad(false);
          return;
        }

        // const cashfree = window.Cashfree({
        //   mode: "sandbox"
        // });
        const cashfree = window.Cashfree({
          mode: "production"
        });

        const checkoutOptions = {
          paymentSessionId: payment_session_id,
          redirectTarget: "_modal",
        };

        console.log('Opening Cashfree checkout with options:', checkoutOptions);
        cashfree.checkout(checkoutOptions).then(async (result) => {
          if (result.error) {
            console.error('Cashfree checkout error or closed:', result.error);
            handleCTPaymentFailed({
              courseName: currentCourse.title,
              amount: totalPayable,
              gateway: 'CASHFREE',
              error: result.error.message || 'Payment closed or failed'
            });
            setIsLoad(false);
          } else if (result.redirect) {
            console.log('Cashfree payment redirecting...');
            // Most tracking should happen on return, but we can log intent
          } else {
            console.log('Cashfree payment completed successfully in-modal');
            console.log('Full Cashfree result object:', result);
            try {
              // Fetch payment details directly from Cashfree API
              let paymentId = null;

              if (orderId) {
                try {
                  console.log('Fetching payment details from Cashfree API for orderId:', orderId);

                  // Call Cashfree API directly to get cf_payment_id
                  // const cashfreePaymentResponse = await axios.get(
                  //   `https://sandbox.cashfree.com/checkout/api/checkouts/payments?order_id=${orderId}`
                  // );
                  const cashfreePaymentResponse = await axios.get(
                    `https://api.cashfree.com/checkout/api/checkouts/payments?order_id=${orderId}`
                  );

                  console.log('Cashfree payments API response:', cashfreePaymentResponse.data);

                  // Extract cf_payment_id from the response
                  if (cashfreePaymentResponse.data?.cf_payment_id) {
                    paymentId = cashfreePaymentResponse.data.cf_payment_id;
                  } else if (Array.isArray(cashfreePaymentResponse.data) && cashfreePaymentResponse.data.length > 0) {
                    paymentId = cashfreePaymentResponse.data[0].cf_payment_id;
                  }

                  console.log('Extracted cf_payment_id from Cashfree API:', paymentId);
                } catch (fetchError) {
                  console.error('Error fetching from Cashfree API:', fetchError);
                  // Continue without payment ID if API call fails
                }
              }

              // Call manual verification API for Cashfree payment
              if (orderId) {
                const verificationPayload = {
                  paymentId: paymentId || orderId, // Use cf_payment_id if available, fallback to orderId
                  type: 'CASHFREE',
                  orderId: orderId
                };

                console.log('Calling manual verification with payload:', verificationPayload);

                try {
                  const verificationResponse = await axios.post(
                    `${cmsRedisBaseDomain}/payment/v2/manualVerification`,
                    verificationPayload
                  );
                  handleCTPaymentCompletedCourse({
                    paymentStatus: "Success",
                    courseName: currentCourse?.clevertapData?.name,
                    courseCategory: currentCourse?.clevertapData?.courseCategory,
                    startDate: formData.startDate,
                    endDate: formData.sdate,
                    date: formData.sdate,
                    pageName: window.location.href,
                    checkoutUrl: window.location.href,
                    pageUrl: window.location.href,
                    fee: courseFee,
                    timings: currentCourse.timing,
                    tenure: currentCourse?.tenure,
                    onlineMode: currentCourse?.onlineInfo?.courseMode,
                    residentialMode: currentCourse?.residentialInfo?.courseMode,
                    nonResidentialMode: currentCourse?.nonResidentialInfo?.courseMode,
                    residentialLocation: currentCourse?.residentialInfo?.residentialMode,
                    nonResidentialLocation: currentCourse?.nonResidentialInfo?.nonResidentialMode,
                    courseType: currentCourse?.clevertapData?.courseType,
                    courseCertificate: currentCourse?.clevertapData?.courseCertificate,
                    courseSubType: currentCourse?.clevertapData?.courseSubType,
                    language: currentCourse?.language,
                    courseTopCategory: currentCourse?.clevertapData?.courseTopCategory,
                    mode: formData.mode,
                    batchNo: currentCourse.batch,
                    preRequisite: currentCourse?.clevertapData?.coursePreRequisite,
                    status: "Success",
                    name: formData.name,
                    emailId: formData.email,
                    phoneNumber: formData.phone,
                    state: formData.state,
                    city: formData.city,
                    pinCode: formData.pincode,
                    gender: formData.gender?.toUpperCase(),
                    age: formData.AGE,
                    nationality: formData.nationality,
                  });
                  console.log('Manual verification response:', verificationResponse.data);
                } catch (verificationError) {
                  console.error('Manual verification error:', verificationError);
                  // Continue with email and navigation even if verification fails
                }
              }

              if (mailTemplateToSend) {
                await axios.post(`${authBaseDomain}/ali/mail`, mailTemplateToSend);
              }
            } catch (mailError) {
              console.error('Failed to send confirmation mail:', mailError);
            }
            navigate(`/enrollment_thankyou/${currentCourse.key}`);
            setIsLoad(false);
          }
        }).catch(err => {
          console.error('Cashfree SDK error:', err);
          setIsLoad(false);
        });
      }
    } catch (error) {
      console.error('Payment processing error:', error);
      if (error.response) {
        console.error('Payment processing error DATA:', error.response.data);
      }

      setIsLoad(false);
    }
  };

  const pickMail = () => {
    const { mode, residental } = resolveEnrollmentFields();
    if (mode === 'ONLINE') {
      setmail(currentCourse?.templateId?.templateOnline)
      return currentCourse?.templateId?.templateOnline
    } else if (mode === 'OFFLINE' && residental === '') {
      setmail(currentCourse?.templateId?.templateOnline)
      return currentCourse?.templateId?.templateOnline
    } else {
      if (residental === 'RESIDENTIAL') {
        console.log(currentCourse?.templateId?.templateOffline?.templateResidential)
        setmail(currentCourse?.templateId?.templateOffline?.templateResidential)
        return currentCourse?.templateId?.templateOffline?.templateResidential
      } else {
        setmail(currentCourse?.templateId?.templateOffline?.templateNonResidential)
        return currentCourse?.templateId?.templateOffline?.templateNonResidential
      }
    }
  }

  // Occupancy TTC uses the same payload shape as on-campus residential courses
  const resolveEnrollmentFields = () => {
    if (currentCourse?.occupancyFees) {
      const type = new URLSearchParams(window.location.search).get('type');
      const fee = type ? currentCourse.occupancyFees[type] : null;
      if (fee != null) {
        return {
          mode: 'OFFLINE',
          residental: 'RESIDENTIAL',
          fee,
        };
      }
    }
    return {
      mode: formData.mode,
      residental: formData.residental,
      fee: courseFee,
    };
  };


  const handleSubmit1 = async (opts = {}) => {
    const { directCashfree = false, totalPayable = null } = opts || {};
    const { mode: enrollmentMode, residental: enrollmentResidental, fee: enrollmentFee } = resolveEnrollmentFields();

    if (currentCourse?.occupancyFees && new URLSearchParams(window.location.search).get('type')) {
      setFormData((prev) => ({
        ...prev,
        mode: enrollmentMode,
        residental: enrollmentResidental,
      }));
      setCourseFee(enrollmentFee);
      localStorage.setItem('isResidential', 'true');
    }

    const allowedUrls = [
      "/asana-regular-classes-on-campus",
      "/asana-regular-classes-on-campus-women",
      "/asana-regular-classes-online",
      "/weekend-classes",
      "/weekend-classes-online",
      "/childrens-regular-classes",
      "/childrens-weekend-classes-on-campus",
      "/advanced-regular-yoga-classes",
      "/meditation-foundation-course-online",
      "/regular-meditation-classes-online",
      "/couples-classes",
      // "/IBY-course",
      "/regular-pregnacy-classes",
      "/department-of-rehabilitation-and-physiotherapy",
      // "/healthy-weightloss-wellness-retreat",
      // "/deep-dive-yoga-meditation-retreat",
      // "/forest-yoga-retreat"
    ];

    const list21DaysCourse = [
      "/21-days-better-living-course",
      "/21-days-better-living-course-batch-2",
      "/21-days-better-living-course-batch-3",
    ]

    const list7DaysCourse = [
      "/7-days-camp-english",
      "/7-days-camp",
    ]

    const isOneMonthTTC = () => {
      return window.location.pathname === '/enrollment/one-month-ttc';
    }

    const isPartTimeTTCOnCampusEnglish = () => {
      return window.location.pathname === '/enrollment/200-hrs-part-time-ttc-on-campus-english';
    }

    const isPartTimeTTCOnlineEnglish = () => {
      return window.location.pathname === '/enrollment/200-hrs-part-time-ttc-online-english';
    }


    const isPartTimeTTCOnline = () => {
      return window.location.pathname === '/enrollment/200-hrs-part-time-ttc-online';
    }

    const isWeekendTeacherTraining = () => {
      return window.location.pathname === '/enrollment/weekend-teacher-training-course';
    }

    const isTwoYearTTC = () => {
      return window.location.pathname === '/enrollment/two-year-ttc';
    }

    const isOneYearTTC = () => {
      return window.location.pathname === '/enrollment/one-year-ttc';
    }

    const isThreeMonthAdvanceTTC = () => {
      return window.location.pathname === '/enrollment/3-months-advanced-teacher-training-course';
    }



    const isNineHundredHourAdvanceTTC = () => {
      return window.location.pathname === '/enrollment/900-hours-advanced-teacher-training-course';
    }

    const isSevenMonthTTC = () => {
      return window.location.pathname === '/enrollment/seven-month-ttc';
    }

    const isFiveOnlineTTC = () => {
      return window.location.pathname === '/enrollment/500-hrs-online-yoga-teacher-training-course-intermediate-level';
    }

    const isChildRegular = () => {
      return window.location.pathname === '/enrollment/childrens-regular-classes';
    }

    const isWeekendAsanaClasses = () => {
      return window.location.pathname === '/enrollment/childrens-weekend-classes-on-campus';
    }

    const isAdvanceRegular = () => {
      return window.location.pathname === '/enrollment/advanced-regular-yoga-classes';
    }

    const isSevenDayCamp = () => {
      return window.location.pathname === '/enrollment/7-days-camp';
    }

    const isSevenDayEnglish = () => {
      return window.location.pathname === '/enrollment/7-days-camp-english';
    }

    const isTwentyOneBetterLiving = () => {
      return window.location.pathname === '/enrollment/21-days-better-living-course';
    }

    const isTwentyOneBetterLivingBatchTwo = () => {
      return window.location.pathname === '/enrollment/21-days-better-living-course-batch-2';
    }

    const isTwentyOneBetterLivingBatchThree = () => {
      return window.location.pathname === '/enrollment/21-days-better-living-course-batch-3';
    }

    const isBatchSix = () => {
      return window.location.pathname === '/enrollment/200-hrs-part-time-ttc-online-batch-6';
    }

    const isForest = () => {
      return window.location.pathname === '/enrollment/forest-yoga-retreat';
    }

    const isHealthy = () => {
      return window.location.pathname === '/enrollment/healthy-weightloss-wellness-retreat';
    }

    const isAnnualMembership = () => {
      return window.location.pathname === '/enrollment/premium-annual-health-membership' ||
        currentCourse?.key === 'premium-annual-health-membership';
    }

    // Membership is 1 year: "1st Oct 2026" → "1st Oct 2027"
    const getAnnualMembershipEndDate = (startDateStr) => {
      if (!startDateStr) return '';
      const yearMatch = String(startDateStr).match(/(\d{4})\s*$/);
      if (!yearMatch) return '';
      const nextYear = Number(yearMatch[1]) + 1;
      return String(startDateStr).replace(/(\d{4})\s*$/, String(nextYear));
    }








    // Function to check if the current URL includes any allowed URL
    const shouldTriggerEvent = () => {
      return allowedUrls.some(path => window.location.pathname.includes(path));
    };

    const is21DaysCourseshouldTriggerEvent = () => {
      return list21DaysCourse.some(path => window.location.pathname.includes(path));
    };

    const is7DaysCourseshouldTriggerEvent = () => {
      return list7DaysCourse.some(path => window.location.pathname.includes(path));
    };



    // alert('RAzor')
    localStorage.setItem('courseName', currentCourse.title)
    if (!isNaN(enrollmentFee)) {
      localStorage.setItem('courseFee', enrollmentFee)
    }

    localStorage.setItem('courseStartDate', formData.sdate)
    console.log("From Razor ", formData)
    if (formData.terms === false) {
      // alert("20")
      setEmpty(19);
    } else {
      setIsLoad(true);
      const identityKey = `+${formData.phone.replace(/^\+/, '')}`;
      // alert(JSON.stringify(identityKey))
      // const identityKey = '++919035435720';
      const identityVerified = `+${formData.phone.replace(/^\+/, '')}`;
      // alert(JSON.stringify(identityVerified))
      let body = {
        personalDetails: {
          name: formData.name,
          emailId: formData.email,
          phone: identityVerified,
          addressLane1: formData.address1,
          addressLane2: formData.address2,
          country: formData.country,
          state: formData.state,
          city: formData.city,
          pincode: formData.pincode,
          gender: formData.gender?.toUpperCase(),
          age: formData.AGE,
          nationality: formData.nationality,
          identity: identityVerified
        },

        uploadedDocument: formData.uploadedDocument,
        startDate: formData.startDate,
        // endDate: formData.endDateFormat,
        endDate: localStorage.getItem('courseEndDate') ? localStorage.getItem('courseEndDate') : null,
        academicQualification: qualificationData,
        workExperience: listData,
        others: {
          medicalHistory: formData.medicalstatus,
          howDoYouHearAboutUs: formData.source || formData.sourceinfo,
        },
        courseDetails: {
          courseId: currentCourse.key,
          courseName: currentCourse.title,
          mode: enrollmentMode,
          subMode: enrollmentResidental,
          batch: currentCourse.batch,
          imageAsset: courseAsset1,
          certificateImgAsset: courseAsset2,
          // date:courseDate,
          date: formData.sdate,
          timing: currentCourse.timing
        },
        userId: localStorage.getItem('userAppId') ? localStorage.getItem('userAppId') : null
      }


      console.log('Form data uploadedDocument before API call:', formData.uploadedDocument);
      console.log('Full formData object:', formData);

      let body1 = {
        personalDetails: {
          name: formData.name,
          emailId: formData.email,
          phone: identityVerified,
          addressLane1: formData.address1,
          addressLane2: formData.address2,
          country: formData.country,
          state: formData.state,
          city: formData.city,
          pincode: formData.pincode,
          gender: formData.gender?.toUpperCase(),
          age: formData.AGE,
          nationality: formData.nationality,
          identity: identityVerified
        },

        uploadedDocument: formData.uploadedDocument,
        startDate: formData.startDate,
        endDate: localStorage.getItem('courseEndDate') ? localStorage.getItem('courseEndDate') : null,
        academicQualification: qualificationData,
        workExperience: listData,
        others: {
          medicalHistory: formData.medicalstatus,
          howDoYouHearAboutUs: formData.source || formData.sourceinfo,
        },
        courseDetails: {
          courseId: currentCourse.key,
          courseName: currentCourse.title,
          mode: enrollmentMode,
          batch: currentCourse.batch,
          imageAsset: courseAsset1,
          certificateImgAsset: courseAsset2,
          // date:courseDate,
          date: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
          timing: currentCourse.timing
        },
        userId: localStorage.getItem('userAppId') ? localStorage.getItem('userAppId') : null
      }

      console.log(mail)

      let mailTemplate;

      // let mailTemplate = {
      //   type: 'INFO_TYI',
      //   HTMLTemplate: pickMail(),
      //   subject: 'Enrollment Confirmation',
      //   data: {
      //     name: formData.name
      //   },
      //   receivers: [formData.email, 'info@theyogainstitute.org']
      // }

      const identityKey2 = `+${formData.phone.replace(/^\+/, '')}`;

      const identityVerified2 = `+${formData.phone.replace(/^\+/, '')}`;



      if (isOneMonthTTC()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE200_1M_ONLINE_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "200-Hour Yoga Teacher Training Course - 1 Month Yoga TTC Online & On Campus - English - Batch 1",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Saturday",
            time: "10:00 am to 6:00 pm ",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }


      } else if (isPartTimeTTCOnCampusEnglish()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE_200_HRS_ONLINE_CONFIRMATION_MAIL",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "200 Hours Yoga Teacher Training Course - 2 Months Yoga TTC Online and On Campus - English - Batch 2",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Friday",
            time: "12:00 noon - 4:00 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isPartTimeTTCOnlineEnglish()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE200_2M_ONLINE_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "200-Hour Yoga Teacher Training Online Course - 2 Months TTC Online - English - Batch 3",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Friday",
            time: "Morning: 7:00 am - 8:30 am and Evening : 6:30 pm - 8:30 pm ",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isPartTimeTTCOnline()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE200_2M_ONLINE_HINDI_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "200 Hours Hindi Teacher Training Course - 2 Months TTC Online - Hindi - Batch 4",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Saturday",
            time: "1:00 pm - 4:30 pm ",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isWeekendTeacherTraining()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE200_WEEKEND_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "200 Hours Yoga TTC  - 3 Months Weekend Yoga Teacher Training Course Online - English - Batch 5",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Saturday & Sunday",
            saturdayTime: "10:00 am – 8:30 pm ",
            sundayTime: "10:00 am – 1:30 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isTwoYearTTC()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE900_2Y_ON_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "900 Hours YTTC - 2 Years Advanced Yoga Teacher Training Certificate Course Online & On Campus - English",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Saturday & Sunday",
            saturdayTime: "4:30 pm – 7.30 pm ",
            sundayTime: "9:30 am – 1:30 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isOneYearTTC()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE900_1Y_ON_HINDI_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "900 Hours Yoga TTC - 1 Year Advanced Yoga Teacher Training Course Online & On-Campus - Hindi",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Friday",
            time: "1:30 pm - 4:00 pm ",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isThreeMonthAdvanceTTC()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE900_3M_ONLINE_NONRES_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "900 Hours Yoga TTC - 3 Months Teacher Training Course On Campus - English",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Saturday",
            time: "6:30 am to 8:00 pm ",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isNineHundredHourAdvanceTTC()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE900_4M_ON_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "900 Hours Yoga TTC - 4 Months Online Yoga Teacher Training Course - English",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Saturday",
            time: "7:00 am to 9:00 am ",
            eveningTime: "4:30 pm to 8:00 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isSevenMonthTTC()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE900_7M_ON_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "900 Hours Yoga TTC - 7 Months Yoga Teacher Training Course Online & On Campus - English",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Saturday",
            time: "5:00 p.m. - 8:00 p.m.",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isFiveOnlineTTC()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE500_3M_ON_TTC",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "500-Hour Yoga Teacher Training Online Course - 3 Months Yoga TTC - English",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Saturday",
            time: "7:00 am - 8:30 am ",
            eveningTime: "4:30 pm - 8:30 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isChildRegular()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE_ADVANCED_CHILDREN",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "Children\'s Yoga Classes (Regular) - On Campus",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Mon, Tues, Thurs, Fri",
            time: "4:00 pm -5:00 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isWeekendAsanaClasses()) {
        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE_ADVANCED_CHILDREN_WEEKEND",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "Children\'s Weekend Yoga Class - On Campus",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Saturday & Sunday",
            time: "8:00 am - 9:30 am",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }
      } else if (isAdvanceRegular()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "ADVANCED_REGULAR_YOGA_CLASS_1",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "Advanced Yoga Asana Regular Class - Online (Only for TYI Teachers)",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday, Wednesday, Friday, Tuesday, Thursday & Saturday",
            time: "Morning: 6:30 am - 8:00 am, Evening: 5:30 pm - 7:00 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isSevenDayCamp()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "CAMP_FOR_7_DAYS_HEALTH_HINDI",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "7 Days Health Camp - On Campus - Yoga Camp - Hindi",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Saturday to Friday",
            time: "7:00 am - 7:00 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isSevenDayEnglish()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "CAMP_FOR_7_DAYS_HEALTH",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "7 Days Health Camp - On Campus - Yoga Camp - English",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Saturday to Friday",
            time: "7:00 am - 7:00 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isTwentyOneBetterLiving()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "CAMP_FOR_21_DAYS_BATCH_1",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "21-Days Better Living Yoga Course - Morning Online and On Campus – English - Batch 1",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Sunday to Saturday",
            time: "Morning: 7:00 am – 8:30 am",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isTwentyOneBetterLivingBatchTwo()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "CAMP_FOR_21_DAYS_BATCH_2",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "21-Days Better Living Yoga Course - Evening - Online & On Campus – English - Batch 2",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Sunday to Saturday",
            time: "Evening 6:30 pm – 8:00 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isTwentyOneBetterLivingBatchThree()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "CAMP_FOR_21_DAYS_BATCH_3",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "21-Days Better Living Yoga Course - Evening - Online & On Campus – Hindi - Batch 3",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Sunday to Saturday",
            time: "Evening 6:30 pm – 8:00 pm",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      } else if (isBatchSix()) {

        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "COURSE200_2M_ONLINE_TTC_BATCH_6",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData.name,
            emailId: formData.email,
            phoneNumber: identityVerified2,
            gender: formData.gender?.toUpperCase(),
            country: formData.country,
            courseName: "200-Hour Yoga Teacher Training Online Course - 3 Months TTC Online - English - Batch 6",
            modeOfAttending: formData.mode,
            batchStartDate: formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate,
            days: "Monday to Saturday",
            time: "5:00 am to 7:30 am",
            timeZone: 'IST'

          },
          receivers: [
            formData.email
          ]
        }

      }
      else if (isForest()) {
        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "FOREST_YOGA_RETREAT_ONE",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData?.name,
            dates: currentCourse?.dates,
            checkInDate: formData?.sdate != 'No date Selected' ? formData?.sdate : formData?.startDate
          },
          receivers: [
            formData.email
          ]
        }
      } else if (isHealthy()) {
        mailTemplate = {
          type: "INFO_TYI",
          HTMLTemplate: "HEALTHY_WEIGHT_LOSS_WELLNESS_RETREAT_ONE",
          subject: "🧘‍♂️ Your Yogic Journey Begins Here – The Yoga Institute Welcomes You 🌿",
          data: {
            fullName: formData?.name,
            dates: currentCourse?.dates,
            checkInDate: formData?.sdate != 'No date Selected' ? formData?.sdate : formData?.startDate
          },
          receivers: [
            formData.email
          ]
        }
      } else if (isAnnualMembership()) {
        const startDate = formData.sdate != 'No date Selected' ? formData.sdate : formData.startDate;
        const endDate = getAnnualMembershipEndDate(startDate);
        mailTemplate = {
          type: 'INFO_TYI',
          HTMLTemplate: 'ANNUAL_MEMBERSHIP_CONFIRMATION_MAIL',
          subject: 'Enrollment Confirmation',
          data: {
            name: formData.name,
            startDate,
            endDate,
          },
          receivers: [formData.email, 'info@theyogainstitute.org']
        }
      }
      else {

        mailTemplate = {
          type: 'INFO_TYI',
          HTMLTemplate: pickMail(),
          subject: 'Enrollment Confirmation',
          data: {
            name: formData.name
          },
          receivers: [formData.email, 'info@theyogainstitute.org']
        }
      }







      // let mailTemplate = {
      //   type: 'INFO_TYI',
      //   HTMLTemplate: pickMail(),
      //   subject: 'Enrollment Confirmation',
      //   data: {
      //     name: formData.name
      //   },
      //   receivers: [formData.email, 'info@theyogainstitute.org']
      // }

      try {
        let response
        if (enrollmentMode === 'ONLINE' || (currentCourse.residential === false && currentCourse.nonResidential === false)) {
          response = await axios.post(
            `${cmsBaseDomain}/forms`,
            body1
          )
          // setIsLoad(false);
        } else {
          response = await axios.post(
            `${cmsBaseDomain}/forms`,
            body
          )
          // setIsLoad(false);
        }

        if (response?.data?.success) {
          // Store enrollment form ID for payment processing
          localStorage.setItem('enrollmentFormId', response.data.data['_id']);

          // Check if it's Level 2 course - show confirmation modal instead of payment
          if (window.location.pathname === '/enrollment/higher-diploma-in-yoga-psychotherapy-Counselling') {

            console.log('Level 2 course detected, showing modal');
            setIsLoad(false);
            setShowLevel2ConfirmationModal(true);
            console.log('Modal state set to true');
            return;
          }

          if (currentCourse.key !== 'satsang' && currentCourse.key !== 'samattvam' && currentCourse.key !== 'fullmoon-meditation' && currentCourse.key !== 'yoga-by-the-bay' && currentCourse.key != 'department-of-rehabilitation-and-physiotherapy') { //for residential no payment required

            // Default flow shows gateway selection; directCashfree skips it and opens Cashfree modal immediately.
            setSavedMailTemplate(mailTemplate);
            if (directCashfree) {
              return await handlePaymentSubmit('cashfree', totalPayable || enrollmentFee, mailTemplate);
            }
            setIsLoad(false);
            setShowPaymentGateway(true);
            return;
          } else {
            if (currentCourse.key === 'satsang') {
              await axios.post(`${authBaseDomain}/ali/mail`, mailTemplate);
              navigate('/satsang_thankyou')
            }
            else if (currentCourse.key == 'department-of-rehabilitation-and-physiotherapy') {
              await axios.post(`${authBaseDomain}/ali/mail`, mailTemplate);
              navigate(`/enrollment_submitted/${currentCourse.key}`)
            } else if (currentCourse.key === 'samattvam') {
              // await axios.post(`${authBaseDomain}/ali/mail`, mailTemplate)
              navigate('/samattvam_thankyou')
            } else if (localStorage.getItem('isResidential') == 'true') {//only for residential course without payment navigate to success screen
              navigate(`/enrollment_submitted/${currentCourse.key}`)
            }
            else {
              navigate(`/enrollment_thankyou/${currentCourse.key}`)
            }
          }
        }


      }
      catch (err) {
        setIsLoad(false)
        console.error(err)
      }

    }





  }


  const handleSubmit = async (eOrOpts) => {
    const event = eOrOpts && typeof eOrOpts?.preventDefault === 'function' ? eOrOpts : null;
    const opts = !event && eOrOpts && typeof eOrOpts === 'object' ? eOrOpts : {};
    // alert(JSON.stringify(formData))
    // alert(formData.name)

    // Validation for swadhyaya course - ensure format and date are selected
    const currentPath = window.location.pathname;
    const isSwadhyayaRoute = currentPath === '/enrollment/swadhyaya-and-emo-energy-reset-basic-online';

    if (isSwadhyayaRoute) {
      let hasError = false;

      // Check if format is selected
      if (!formData.mode) {
        setFormatError('Please select a course format');
        hasError = true;
      } else {
        setFormatError('');
      }

      // Check if date is selected
      if (!formData.sdate) {
        setDateError('Please select a course start date');
        hasError = true;
      } else {
        setDateError('');
      }

      // If there are errors, stop submission
      if (hasError) {
        return;
      }
    }

    const isCombinedCourseRoute =
      currentPath === '/enrollment/combined-basic-module-advanced-module' ||
      currentPath === '/enrollment/combined-basic-module-advanced-module-offline';

    if (isCombinedCourseRoute) {
      const getCombinedCourseType = (dateLabel) => {
        const label = (dateLabel || '').toUpperCase();
        if (label.includes('ADVANCE') || label.includes('ICP') || label.includes('INTEGRAL CHAKRA') || label.includes(' - CHA')) {
          return 'advanced';
        }
        if (label.includes('SWADHAY') || label.includes('EMO') || label.includes('SWA')) {
          return 'basic';
        }
        return null;
      };

      const selectedDates = formData.sdate ? formData.sdate.split(' | ').map((date) => date.trim()).filter(Boolean) : [];
      const basics = selectedDates.filter((date) => getCombinedCourseType(date) === 'basic');
      const advanceds = selectedDates.filter((date) => getCombinedCourseType(date) === 'advanced');

      if (basics.length > 1) {
        setDateError('Please select only one Basic Module course date.');
        return;
      }
      if (advanceds.length > 1) {
        setDateError('Please select only one Advanced Module course date.');
        return;
      }
      if (basics.length !== 1 || advanceds.length !== 1) {
        setDateError('Please select one Basic Module and one Advanced Module course date.');
        return;
      }

      setDateError('');
    }

    const array = ["Yoga Classes for Men (Regular Asana) - On Campus",
      "Yoga Classes for Women (Regular Asana) - On Campus",
      "Yoga Asana Regular Classes - (Men & Women) - Online Yoga Classes",
      "Weekend Yoga Asana Classes - (Men & Women) - On Campus",
      "Weekend Yoga Asana Classes - (Men & Women) - Online",
      "Children's Yoga Classes (Regular) - On Campus",
      "Children's Weekend Yoga Class - On Campus",
      "Advanced Yoga Asana Regular Class - Online (Only for TYI Teachers)",
      "Regular Pregnancy Yoga Classes - Online & On Campus",
      "Advanced Yoga Asana Regular Class - Online (Only for TYI Teachers)",
      "Healing Yoga Movement & Rhythm - Online",
      "Yog Prayas - Online",
      "Online Meditation Course  (Foundation Course)",
      "Regular Online Meditation Classes",
      // "Couples’ Yoga Classes  - Online",
      "Single Consultation",
      "Extended Consultation",
    ]
    let updatedData = JSON.parse(localStorage.getItem('addressDataNew'))
    let formDataConst = formData;
    formDataConst['gender'] = updatedData?.gender
    const isConsultationCourse = currentPath === '/enrollment/single-consultation' || currentPath === '/enrollment/extended-consultation';
    // setFormData(prevFormData => ({
    //   ...prevFormData,
    //   gender: updatedData?.gender

    // }));
    const isPhysio = currentCourse?.title == 'Department of Rehabilitation and Physiotherapy'
    console.log("form data from sdate ", formData.sdate)
    const isMatch = array.includes(currentCourse?.title);
    console.log("isMatchhhhhh ", isMatch)
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    const { mode: enrollmentMode } = resolveEnrollmentFields();

    // setEndDate(formData.endDate?.value, formData.startDate)
    if (
      formData.name === '' ||
      formData.name === undefined ||
      formData.name === null
    ) {
      // alert("1")
      setEmpty(1)
      setEditStudentOpen(true);
    } else if (formData.email === '' || !validateEmail(formData.email) || formData.email === undefined ||
      formData.email === null) {
      // alert("2")
      setEmpty(2)
      setEditStudentOpen(true);
    } else if (
      formData.phone === '' ||
      formData.phone?.length < 6 ||
      formData.phone?.length > 15 ||
      formData.phone === undefined
    ) {
      // alert("3")
      setEmpty(3)
      setEditStudentOpen(true);

    } else if (formData.address1 === '') {
      // alert("4")
      setEmpty(4)

      setEditStudentOpen(true);
    }
    else if (formData.country === '') {
      // alert("5")
      setEmpty(5)
      setEditStudentOpen(true);
    }
    else if (formData.pincode === '') {
      // alert("6")
      setEmpty(8)
      setEditStudentOpen(true);
    } else if (formData.gender === '') {
      // alert("7")
      console.log(formData);

      setEmpty(11)
      setEditStudentOpen(true);
    } else if (enrollmentMode === '') {
      // alert("11")
      setEmpty('mode')
    } else if ((isMatch || isPhysio) && formData.startDate === '') {
      // alert('No')
      // alert(formData.startDate)

      setEmpty(21)
    } else if ((formData.sdate === '' || formData.sdate === 'No date Selected') && !isPhysio) {
      // alert("8")
      setEmpty(18)
    }

    else if (isMatch && formData.endDate === '' && !isPhysio && !isConsultationCourse) {
      console.log("Form Data Start Date ", formData.startDate)
      // alert("12")

      setEmpty(20)
    }
    else if (window.location.pathname === '/enrollment/higher-diploma-in-yoga-psychotherapy-Counselling' && (!formData.uploadedDocument || formData.uploadedDocument.length === 0)) {
      setUploadError(true)
    }
    else {
      // alert(formData.endDate)
      if (localStorage.getItem('isRegular') == 'true' && !isPhysio) {//end date caculate for Regular courses 
        setEndDate(formData.endDate, formData.startDate)
      }
      await handleSubmit1(opts);
      handleCTProccedToPayment({
        courseTitle: currentCourse?.clevertapData?.name,
        date: formData.sdate,
        fees: currentCourse?.fees,
        courseFee: courseFee,
        mode: formData.mode,
        timing: currentCourse?.timing,
        tenure: currentCourse?.tenure,
        courseCategory: currentCourse?.clevertapData?.courseCategory,
        courseSubType: currentCourse?.clevertapData?.courseSubType,
        onlineMode: currentCourse?.onlineInfo?.courseMode,
        residentialMode: currentCourse?.residentialInfo?.courseMode,
        nonResidentialMode: currentCourse?.nonResidentialInfo?.courseMode,
        residentialLocation: currentCourse?.residentialInfo?.residentialMode,
        nonResidentialLocation: currentCourse?.nonResidentialInfo?.nonResidentialMode,
        courseCertificate: currentCourse?.clevertapData?.courseCertificate,
        courseType: currentCourse?.clevertapData?.courseType,
        language: currentCourse?.language,
        PreRequisite: currentCourse?.clevertapData?.coursePreRequisite,
        courseTopCategory: currentCourse?.clevertapData?.courseTopCategory,
        category: currentCourse?.category,
        batch: currentCourse?.batch,
        nonResidential: currentCourse?.nonResidential,
        residential: currentCourse?.residental,
        online: currentCourse?.online,
        age: formData.AGE,
        nationality: formData.nationality
      })
      ReactGA.event('begin_checkout', {
        currency: 'INR',
        value: courseFee ? courseFee : 0,
        items: [{
          item_name: currentCourse?.title,
          item_id: currentCourse?.courseCategory,
          price: courseFee ? courseFee : 0,
          quantity: 1
        }]
      });
      console.log('begin_checkout', {
        currency: 'INR',
        value: courseFee ? courseFee : 0,
        items: [{
          item_name: currentCourse?.title,
          item_id: currentCourse?.courseCategory,
          price: courseFee ? courseFee : 0,
          quantity: 1
        }]
      });
      setupUserProfile(formData);
      try {
        let token = localStorage.getItem('authorizationToken')
        if (token && !axios.defaults.headers?.Authorization) {
          // console.log('Current Request Headers: 2', axios.defaults.headers);
          axios.defaults.headers['Authorization'] = `Bearer ${token}`;
          delete axios.defaults.headers.common['authorization'];
        }

        const identityVerified2 = `+${formData.phone.replace(/^\+/, '')}`;

        let payload = {
          firstName: formData?.name, lastName: formData?.lname,
          addressLine1: formData?.address1, addressLine2: formData?.address2,
          country: formData?.country, state: formData?.state,
          city: formData?.city, pincode: formData?.pincode,
          gender: formData?.gender,
          identity: identityVerified2
        }
        // alert(JSON.stringify(payload))
        await axios.put(`${authBaseDomain}/user/update`, payload, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        dispatch(fetchUserData());
      } catch (err) {
        console.log(err);
      }
    }
  }


  const handleFormatSelection = (format) => {
    setSelectedFormat(format);
    if (format === "Online") {
      setCourseStartDateLabel("Select a start date from the available online dates.");
    } else if (format === "On-Campus") {
      setCourseStartDateLabel("Select a start date from the available offline dates.");
    }
  };

  const handleDateSelection = (date) => {
    setFormData((prev) => ({ ...prev, startDate: date }));
  };

  const [courseStartDateLabel, setCourseStartDateLabel] = useState("Please select course format first to select Course start date and move forward to purchase course");
  const [selectedFormat, setSelectedFormat] = useState(null);

  useEffect(() => {
    // Start time when the component mounts
    const mountTime = Date.now();
    setStartTime(mountTime);

    // Retrieve or generate the session ID
    let session = localStorage.getItem('sessionId');
    if (!session) {
      session = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      localStorage.setItem('sessionId', session);
    }
    setSessionId(session);

    return () => {
      // End time when the component unmounts
      const endTime = Date.now();

      // Calculate the session duration in seconds
      const sessionDuration = ((endTime - mountTime) / 1000).toFixed(2);

      const pageName = currentCourse?.title + " Enrollment Form";
      const lastPageUrl = document.referrer || 'N/A';
      const pageUrl = window.location.href;
      //const loggedIn = localStorage.getItem('isLoggedIn') === 'true' ? 'Yes' : 'No'; // Adjust based on your auth logic
      const uniqueViewId = Math.floor(Math.random() * 1000); // Replace with actual logic

    };
  }, []);


  useEffect(() => {
    const currentPageUrl = window.location.href;
    handleCTCoursePaymentPageVisit(currentPageUrl);
  }, []);

  return (
    <>
      <div className="enrollment_container ">

        {!showPaymentGateway ? (
          <div className="container_page1_wrapper">
            {bold < 5 && (
              <div className="header">
                {shouldRedirectToPsychotherapyPrograms ? (
                  <a href={psychotherapyProgramsUrl} style={{ textDecoration: 'none' }}>
                    <button className="x" type="button">
                      <img src='/images/close.svg' style={{ position: 'relative', top: '2px' }} alt='' loading='lazy' />
                      <span className='close_label'>Close</span>
                    </button>
                  </a>
                ) : (
                  <Link to="/courses" style={{ textDecoration: 'none' }}>
                    <button className="x" type="button">
                      <img src='/images/close.svg' style={{ position: 'relative', top: '2px' }} alt='' loading='lazy' />
                      <span className='close_label'>Close</span>
                    </button>
                  </Link>
                )}
                <span className="flower">{legacy2}</span>
                <div className="student">Your Selected Yoga Course Details<br /></div>
              </div>
            )}

            {bold === 0 ? (
              <EnrollmentForm
                setBold={setBold}
                empty={empty}
                formData={formData}
                setFormData={setFormData}
                handleEmpty1={handleEmpty1}
                setEmpty={setEmpty}
                isLoad={isLoad}
                courseDate={courseDate}
                templateKey={currentCourse?.templateId}
                isEditStudentOpen={isEditStudentOpen}
                setEditStudentOpen={setEditStudentOpen}
                qualificationData={qualificationData}
                listData={listData}
                currentCourse={currentCourse}
                courseAsset1={courseAsset1}
                setCourseAsset1={setCourseAsset1}
                courseAsset2={courseAsset2}
                setCourseAsset2={setCourseAsset2}
                handleSubmit={handleSubmit}
                courseFee={courseFee}
                setCourseFee={setCourseFee}
                uploadCheck={uploadCheck}
                setUploadCheck={setUploadCheck}
                uploadError={uploadError}
                setUploadError={setUploadError}
                dateDurationChange={dateDurationChange}
                formatError={formatError}
                setFormatError={setFormatError}
                dateError={dateError}
                setDateError={setDateError}
                setSelectedCourseDuration={setSelectedCourseDuration}
              />
            ) : null}

            {bold === 5 ? (
              <DisclaimerPolicy
                templateKey={currentCourse?.templateId}
                formData={formData}
                qualificationData={qualificationData}
                listData={listData}
                currentCourse={currentCourse}
                courseAsset1={courseAsset1}
                courseAsset2={courseAsset2}
                setBold={setBold}
                courseFee={courseFee}
                courseDate={courseDate}
                setListData={setListData}
                setQualificationData={setQualificationData}
              />
            ) : null}
          </div>
        ) : (
          <PaymentGatewaySelection
            currentCourse={currentCourse}
            formData={formData}
            courseFee={courseFee}
            isLoad={isLoad}
            handlePaymentSubmit={handlePaymentSubmit}
            courseFormattedTitle={currentCourse?.metaDescription}
            courseImage={courseAsset1}
            courseTimings={currentCourse?.timing}
            selectedDuration={selectedCourseDuration}
            onBack={() => setShowPaymentGateway(false)}
            isEditStudentOpen={isEditStudentOpen}
            setEditStudentOpen={setEditStudentOpen}
            setFormData={setFormData}
            empty={empty}
            setEmpty={setEmpty}
            handleSubmit={handleSubmit}
            dateDurationChange={dateDurationChange}
          />
        )}
      </div>

      {/* Level 2 Confirmation Modal */}
      {showLevel2ConfirmationModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999999
          }}
          onClick={(e) => {
            console.log('Overlay clicked');
            if (e.target === e.currentTarget) {
              setShowLevel2ConfirmationModal(false);
              handleCloseNavigation();
            }
          }}
        >
          {console.log('Modal is rendering!')}
          <div
            style={{
              backgroundColor: 'white',
              padding: '40px',
              borderRadius: '12px',
              maxWidth: '500px',
              width: '90%',
              position: 'relative',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => {
                console.log('Close button clicked');
                setShowLevel2ConfirmationModal(false);
                handleCloseNavigation();
              }}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'none',
                border: 'none',
                fontSize: '28px',
                cursor: 'pointer',
                color: '#666',
                lineHeight: 1,
                padding: '5px',
                fontWeight: 'bold'
              }}
            >
              ×
            </button>
            <div style={{
              textAlign: 'center',
              padding: '20px 0'
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '20px',
                color: '#4CAF50'
              }}>
                ✓
              </div>
              <p style={{
                fontSize: '18px',
                color: '#333',
                lineHeight: '1.6',
                margin: 0
              }}>
                Registration link will be sent on your email after approving the certificates you have uploaded
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Enrollment
